import React from 'react';
import SelectedProduct from './SelectedProduct'
import { TbPhotoX } from 'react-icons/tb';
import { cropString, isAllergen, isNewProductOnCatalog, useQuantityProductInCartConference, vibrate } from '../../../Utils/Helpers';
import BadgeNewProduct from './BadgeNewProduct';
import BadgeProductSale from './BadgeProductSale';
import ProductPrice from './ProductPrice';
import { useProductsHook } from '../../../Hooks/ProductsHook';
import { useStoreHook } from '../../../Hooks/StoreHook';
import { useLayoutContext } from '../../../Contexts/LayoutContext';
import { useAddProductContext } from '../../../Contexts/AddProductContext';
import BadgeAllergenTag from './BadgeAllergenTag';

interface CardProductGridImageProps {
    product: any;
    category: any;
    loading?: boolean;
    className?: any;
}

const CardProductGridImage = ({
    product,
    category,
    loading,
    className,
}: CardProductGridImageProps) => {

    const { setShowAddProduct, setProduct, setCategory } = useAddProductContext();
    const { hasCurrentAddress } = useProductsHook();
    const { openProductToAdd } = useStoreHook();
    const { setEnableLoadProducts } = useLayoutContext();

    const handleProduct = () => {
        if (!hasCurrentAddress(product.slug)) return;

        setShowAddProduct(true);
        setProduct(product);
        setCategory(category);

        if (product.slug) {
            setEnableLoadProducts(false);
        } else {
            openProductToAdd(product, category);
        }
        vibrate();
    }

    const quantitySelected = useQuantityProductInCartConference(product.id);

    return (
        <>
            {!loading
                ?
                    <div onClick={handleProduct} className="relative w-full h-full">
                        
                        {/* ALLERGEN TAG  */}
                        <BadgeAllergenTag product={product} className='absolute w-full h-full z-10' />
                        
                        <div className={`
                            ${className} relative flex flex-col w-full min-h-full hover:text-custom-primary cursor-pointer transition ease-in-out duration-200 rounded-2xl
                            ${isAllergen(product) ? 'opacity-50' : ''}
                            `}>

                            {/* PRODUCT IN CART */}
                            {(quantitySelected > 0) && <SelectedProduct quantity={quantitySelected} />}

                            <div className="w-full h-full rounded-2xl overflow-hidden">
                                <div
                                    className={`relative flex items-center justify-center bg-cover bg-center bg-no-repeat h-full min-h-40 ring-0 ring-opacity-50 ring-gray-200 bg-gray-100 rounded-2xl
                                        overflow-hidden
                                        `}
                                    style={{backgroundImage: `url('${product.photos?.medium}')`}}
                                    >
                                    {!product.photos?.medium && <TbPhotoX className='text-white w-1/3 h-1/2' />}


                                    {/* BADGE FOR NEW PRODUCT ON CATALOG */}
                                    <BadgeNewProduct product={product} className='absolute right-0 top-0 rounded-none rounded-bl-xl rounded-tr-xl' />

                                    {/* PRODUCT SALE  */}
                                    <BadgeProductSale product={product} className='absolute right-0 top-0 rounded-none rounded-bl-xl rounded-tr-xl' />

                                    <span className={
                                        `absolute top-2 left-3 font-semibold text-xs leading-4
                                        ${product.photos?.medium
                                            ? 'drop-shadow-[0_1px_1px_rgba(0,0,0,0.6)] text-white'
                                            : 'text-gray-400'
                                        }
                                    `}>
                                        <ProductPrice
                                            breakLine={product.from_price > 0 || (isNewProductOnCatalog(product.tags) && !product.from_price)}
                                            product={product}
                                            textFromPriceMuted={false}
                                        />
                                    </span>
                                </div>
                                <h3 className={`
                                    absolute bottom-0 w-full py-2 px-3 font-bold text-sm
                                    ${product.photos?.medium
                                        ? 'drop-shadow-[0_1px_1px_rgba(0,0,0,0.6)] text-white'
                                        : 'text-gray-400'
                                    }
                                    `}>
                                    { cropString(product.name, 25) }
                                </h3>
                            </div>
                        </div>
                    </div>
                :
                    <div className={`${className} relative w-full rounded-2xl h-full ring-1 ring-transparent bg-gray-200 animate-pulse`}>
                        <div className="absolute top-0 m-3 bg-gray-100 h-4 w-1/5 rounded-lg"></div>
                        <div className="absolute bottom-0 m-3 bg-gray-100 h-4 w-3/5 rounded-lg"></div>
                    </div>
            }
        </>
    );
};

export default CardProductGridImage;
